import React from 'react';
import Startup from './Startup';
import { Provider } from 'react-redux';
import {NextUIProvider} from "@nextui-org/react";
import store from './store';
import { ToastContainer } from 'react-toastify';


function App() {

  return (
    <Provider store={store}>
      <NextUIProvider locale='it-IT'>
        <Startup />
        <ToastContainer autoClose={5000} />
      </NextUIProvider>
    </Provider>
  );
}

export default App;
